module.exports = __webpack_public_path__ + "static/media/Seawatergreenhouseaus_crop.a7134aa0.jpg";